import { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconPlusCircledFilled = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
  >
    <rect
      width="16"
      height="16"
      rx="8"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5Z"
      fill="white"
    />
    <path
      d="M8.5 8.5V8.16667H8.16667V8.5H8.5ZM8.5 7.5H8.16667V7.83333H8.5V7.5ZM7.5 7.5V7.83333H7.83333V7.5H7.5ZM7.5 8.5H7.83333V8.16667H7.5V8.5ZM8 11.6667C7.90795 11.6667 7.83333 11.592 7.83333 11.5H7.16667C7.16667 11.9602 7.53976 12.3333 8 12.3333V11.6667ZM8.16667 11.5C8.16667 11.592 8.09205 11.6667 8 11.6667V12.3333C8.46024 12.3333 8.83333 11.9602 8.83333 11.5H8.16667ZM8.16667 8.5V11.5H8.83333V8.5H8.16667ZM11.5 8.16667H8.5V8.83333H11.5V8.16667ZM11.6667 8C11.6667 8.09205 11.592 8.16667 11.5 8.16667V8.83333C11.9602 8.83333 12.3333 8.46024 12.3333 8H11.6667ZM11.5 7.83333C11.592 7.83333 11.6667 7.90795 11.6667 8H12.3333C12.3333 7.53976 11.9602 7.16667 11.5 7.16667V7.83333ZM8.5 7.83333H11.5V7.16667H8.5V7.83333ZM8.16667 4.5V7.5H8.83333V4.5H8.16667ZM8 4.33333C8.09205 4.33333 8.16667 4.40795 8.16667 4.5H8.83333C8.83333 4.03976 8.46024 3.66667 8 3.66667V4.33333ZM7.83333 4.5C7.83333 4.40795 7.90795 4.33333 8 4.33333V3.66667C7.53976 3.66667 7.16667 4.03976 7.16667 4.5H7.83333ZM7.83333 7.5V4.5H7.16667V7.5H7.83333ZM4.5 7.83333H7.5V7.16667H4.5V7.83333ZM4.33333 8C4.33333 7.90795 4.40795 7.83333 4.5 7.83333V7.16667C4.03976 7.16667 3.66667 7.53976 3.66667 8H4.33333ZM4.5 8.16667C4.40795 8.16667 4.33333 8.09205 4.33333 8H3.66667C3.66667 8.46024 4.03976 8.83333 4.5 8.83333V8.16667ZM7.5 8.16667H4.5V8.83333H7.5V8.16667ZM7.83333 11.5V8.5H7.16667V11.5H7.83333Z"
      fill="white"
    />
  </SvgIcon>
));
